<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6" style="border-top: solid #f1c40f 4px;">
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon class="w-6 h-6">map</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Pläne</h2>
      </div>
    </div>

    <!-- Standort Selector -->
    <div class="mb-6">
      <label class="block text-sm font-medium text-gray-700 mb-2">Standort auswählen</label>
      <select
        class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[300px]"
        [(ngModel)]="selectedStandortId"
        (change)="onStandortChange()">
        <option [value]="null">Standort auswählen...</option>
        <option *ngFor="let standort of standorte" [value]="standort.id">
          {{ standort.name }}<span *ngIf="standort.nummer"> (Nr. {{ standort.nummer }})</span>
        </option>
      </select>
    </div>

    <!-- Loading Standorte -->
    <div *ngIf="isLoadingStandorte" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <span class="ml-4 text-gray-600">Lade Standorte...</span>
    </div>

    <!-- Loading Plans -->
    <div *ngIf="isLoadingPlans && selectedStandortId" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <span class="ml-4 text-gray-600">Lade Pläne...</span>
    </div>

    <!-- Plans List -->
    <div *ngIf="!isLoadingPlans && selectedStandortId && plans.length > 0" class="mb-6">
      <h3 class="text-lg font-semibold mb-4">Verfügbare Pläne</h3>
      <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
        <div
          *ngFor="let plan of plans"
          (click)="selectPlan(plan)"
          [class.border-blue-500]="selectedPlan?.id === plan.id"
          class="border-2 rounded-lg p-4 cursor-pointer hover:bg-gray-50 transition-colors"
          [class.bg-blue-50]="selectedPlan?.id === plan.id">
          <div class="font-medium text-gray-900">{{ plan.bezeichnung }}</div>
          <div class="text-sm text-gray-500 mt-1" *ngIf="plan.sektion">
            {{ plan.sektion.name }}
          </div>
          <div class="text-xs text-gray-400 mt-2">
            <span *ngIf="plan.active || plan.is_active" class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
              Aktiv
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- No Plans Message -->
    <div *ngIf="!isLoadingPlans && selectedStandortId && plans.length === 0" class="text-center py-8">
      <mat-icon class="text-gray-400 w-24 h-24 mb-4">map</mat-icon>
      <p class="text-gray-500 text-lg">Keine Pläne für diesen Standort gefunden</p>
    </div>

    <!-- Interactive Plan Preview -->
    <div *ngIf="selectedPlan && planImageUrl" class="mt-8">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold">{{ selectedPlan.bezeichnung }}</h3>
        <button
          *ngIf="selectedPlan"
          mat-raised-button
          color="primary"
          (click)="downloadPlanPDF()"
          [disabled]="isDownloadingPDF"
          class="flex items-center">
          <mat-icon *ngIf="!isDownloadingPDF" class="mr-2">picture_as_pdf</mat-icon>
          <mat-progress-spinner *ngIf="isDownloadingPDF" mode="indeterminate" diameter="20" class="mr-2"></mat-progress-spinner>
          <span>{{ isDownloadingPDF ? 'PDF wird erstellt...' : 'PDF herunterladen' }}</span>
        </button>
      </div>
      <app-interactive-plan
        [planImageUrl]="planImageUrl"
        [roomIndicators]="roomIndicators"
        [planId]="selectedPlan.id"
        [readOnly]="true"
        [width]="800"
        [height]="600">
      </app-interactive-plan>
    </div>

    <!-- Loading Plan Image -->
    <div *ngIf="selectedPlan && isLoadingPlanImage" class="text-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <p class="text-gray-500 mt-4">Lade Planbild...</p>
    </div>
  </div>
</div>

